import { Bank, BankDataItem } from '@formunauts/banking/domain';
import { CountryBankData } from './country-bank-data';

/**
 * A general implementation of the country bank data
 */
export class DefaultCountryBankData extends CountryBankData<BankDataItem> {
  protected findEntry(
    bankId: string,
    branchId?: string,
  ): BankDataItem | undefined {
    return this._banks.find((b) => b[1] === bankId);
  }

  protected fromEntry(entry: BankDataItem): Bank.LegacyBank | undefined {
    return entry ? new Bank.LegacyBank(entry[0], entry[2]) : undefined;
  }
}
